<template>
  <div  id="app" class="pa-0" v-if="fontFamily" :style="'--fontFamily: ' + fontFamily.value">

    <!-- Alert -->
    <alert-message :dialog="dialog"></alert-message>

    <template v-if="layout == guestLayout">
      <guest-layout></guest-layout>
    </template>

  </div>
</template>

<script>
import GuestLayout from "@/layouts/GuestLayout";

import AlertMessage from "./components/dialogBox/AlertMessage";
import { EventBus } from "@/event-bus";
import { mapGetters } from "vuex";
import DEFINES from "@/defines";

export default {
  name: "app",
  components: {
    GuestLayout,
    AlertMessage
  },
  data() {
    return {
      loader: false,
      dialog: {
        show: false,
        text: "",
        color: ""
      },
      guestLayout: DEFINES.LAYOUT_GUEST,
      snackbar:{
        show: false,
        text: "",
        color: "primary",
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 5000,
      }
    };
  },
  computed: {
    ...mapGetters("app", {
      layout: "appLayout",
      fontFamily : "fontFamily"
    })
  },

  mounted(){
    this.loadFonts();
  },
   watch: {
    fontFamily: {
      deep: true,
      handler:function(){
        this.loadFonts();
      },
    },
  },

  created() {
    EventBus.$on("showMessage", payload => {
      this.dialog.show = true;
      this.dialog.color = payload.color;
      this.dialog.text = payload.message;
    });

    EventBus.$on("hideMessage", payload => {
      this.dialog.show = false;
    });

    EventBus.$on("showAlert", payload => {
      this.snackbar.color = payload.color || "primary";
      this.snackbar.text = payload.message;
      this.snackbar.y = payload.y || 'top';
      this.snackbar.x = payload.x || 'right';
      this.snackbar.mode = payload.mode || '';
      this.snackbar.timeout = payload.timeout || 5000;
      this.snackbar.show = true;
    });

    EventBus.$on("hideAlert", payload => {
      this.snackbar.show = false;
      this.snackbar.text = null;
    });

    EventBus.$on("showLoader", payload => {
      this.loader = true;
    });

    EventBus.$on("hideLoader", payload => {
      this.loader = false;
    });
  },

  methods: {
    loadFonts(){
      var _this = this;
      var junction_font = new FontFace(this.fontFamily.value, `url(${this.fontFamily.url})`);
        junction_font.load().then(function(loaded_face) {
          document.fonts.add(loaded_face);
            document.body.style.fontFamily = _this.fontFamily.value;
        }).catch(function(error) {
      });
    },
  }
};
</script>
<style scoped>
.v-alert.v-alert--outline {
    border: 3px solid var(--v-primary-base) !important;
    line-height: 5px;
}
#app {
  font-family: var(--FontFamily) !important;
}
</style>
